module.exports = __webpack_public_path__ + "static/media/usdt_to_shiden.8f8cbcb0.png";